import { render, staticRenderFns } from "./RemoteControlBar.vue?vue&type=template&id=af5a5602&scoped=true&lang=pug&"
import script from "./RemoteControlBar.vue?vue&type=script&lang=js&"
export * from "./RemoteControlBar.vue?vue&type=script&lang=js&"
import style0 from "./RemoteControlBar.vue?vue&type=style&index=0&id=af5a5602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5a5602",
  null
  
)

export default component.exports